<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <import-navigator currentStep="upload"></import-navigator>
                <div class="wrap-text">
                    <b>
                        Load data
                    </b>
                </div>
            </div>
        </div>
        <div class="middle-part load-data">
            <div class="load-data_field">
                <div class="font-small">
                    selected data
                </div>
                <div>
                    <b>{{filename}}</b>
                </div>
                <div class="font-small">
                    <label for="file">
                        re-select from your computer
                    </label>
                    or 
                    <label (click)="pickAndDownloadFile()">
                        re-select from your Google Drive
                    </label>
                </div>

                <input type="file" accept=".xlsx"
                       id="file" name="file" enctype="multipart/form-data"
                       (change)="handleFileInput($event.target.files)">
            </div>
            <div class="actions">
                <div class="actions-links" *ngIf="false">
                    <span>download <a>example Excel data-set</a></span>
                    <span class="divider">|</span>
                    <span>review <a>data formatting directions</a></span>
                </div>

                <div class="actions-create">
                    <div class="wrap-btn">
                        <button [ngClass]="{'disabled':!fileToUpload, 'btn':true, 'btn-green': true, 'btn-middle':true}" (click)=uploadFile()>
                            Update file
                        </button>
                    </div>
                    <a *ngIf="false">other options</a>
                </div>
            </div>
        </div>
    </div>
</main>
